// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activate[data-v-77e653a5]:hover {\n  box-shadow: 0px 0px 0px 2px #928b8b;\n}\n.activate--alert[data-v-77e653a5]:hover {\n  color: #b10000;\n}", ""]);
// Exports
module.exports = exports;
